














import { Vue, Component } from 'vue-property-decorator';
@Component
export default class Datasource extends Vue {
  bread = [{ name: '数据' }, { name: '数据接入' }];
}
